import HttpService from "../util/HttpService";
import {CustomerWrapperDto} from "../dto/CustomerWrapperDto";
import {InputDropdownParameterDto} from "../dto/InputDropdownParameterDto";
import ClientHttpService from "../util/ClientHttpService";
import {CustomerVerificationScheduleDto} from "../dto/CustomerVerificationScheduleDto";
import {UserMstDto} from "../dto/UserMstDto";
import ParamEncrypt from "../util/ParamEncrypt";

const CONTEXT_PATH = "/cwm/api/v2";
class CustomerService {
    saveCustomerData = (customerDto: CustomerWrapperDto) => {
        return HttpService.post(CONTEXT_PATH.concat("/customer-detail-service/customer-save"), ParamEncrypt.encryptObject(customerDto));
    }
    getCustomerByUserName = (userName: string) => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-detail-service/get-customer-by-username/") + ParamEncrypt.encryptData(userName));
    }
    getCustomerCINByLoggedUser = () => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-detail-service/get-customer-cin-by-username"));
    }

    getCommonDropdown = (inputDropdownParameterDto: InputDropdownParameterDto) => {
        return ClientHttpService.post(CONTEXT_PATH.concat("/common-dropdown-service/list-item"), ParamEncrypt.encryptObjectWithEnvKey(inputDropdownParameterDto));
    }
    getCommonDropdownList = (inputDropdownParameterDto: InputDropdownParameterDto[]) => {
        return ClientHttpService.post(CONTEXT_PATH.concat("/common-dropdown-service/list-item-list"), ParamEncrypt.encryptObjectWithEnvKey(inputDropdownParameterDto));
    }
    getDateScheduleForVerification = () => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-detail-service/get-dates-schedule"));
    }
    getTimeScheduleForVerification = (selectedDate: any) => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-detail-service/get-time-schedule/") + selectedDate);
    }
    saveCustomerVerificationSchedule = (userName: string, payload: CustomerVerificationScheduleDto) => {
        return HttpService.post(CONTEXT_PATH.concat("/customer-detail-service/save-customer-verification-schedule/") + ParamEncrypt.encryptData(userName), ParamEncrypt.encryptObject(payload));
    }
    generateCustomerSummaryPdf = (customerId: number) => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-detail-service/generate-customer-summary-pdf/") + ParamEncrypt.encryptData(String(customerId)));
    }
    getDashboardData = (customerId: number) => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-detail-service/get-account-card-details/") + ParamEncrypt.encryptData(String(customerId)));

    }
    getCustomerDateByCin = (cin: string) => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-detail-service/get-customer-by-cin/") + ParamEncrypt.encryptData(cin));
    }

    getExactCustomerByCin = (cin: string) => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-detail-service/get-exact-customer-by-cin/") + ParamEncrypt.encryptData(cin));
    }
    getJointReferenceNumberByUsername = () => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-detail-service/get-joint-reference-number-by-username"));
    }

    validateReferenceNumber = (reference: string) => {
        return ClientHttpService.get(CONTEXT_PATH.concat("/customer-detail-service/validate-reference-number/") + ParamEncrypt.encryptDataWithEnvKey(reference));
    }

    getUserProfileDetail = () => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-detail-service/get-user-profile-detail"));
    }

    getPortfolioWiseFundDetails = (portfolio: string) => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-detail-service/get-portfolio-wise-fund-details/").concat(ParamEncrypt.encryptData(portfolio)));
    }
    getCinWiseFundDetails = (cinNumber: string) => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-detail-service/get-customer-fund-details/").concat(ParamEncrypt.encryptData(cinNumber)));
    }

    getCustomerVerificationStatuses = (customerId: number) => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-detail-service/get-customer-verification-status/") + ParamEncrypt.encryptData(String(customerId)));
    }
    getAllNotification = () => {
        return HttpService.get(CONTEXT_PATH.concat("/notification/get-all-notification"));
    }

    markAsReadNotification = (id: number) => {
        return HttpService.get(CONTEXT_PATH.concat("/notification/read-notification/").concat(ParamEncrypt.encryptData(String(id))));
    }

    markAllAsReadNotification = () => {
        return HttpService.get(CONTEXT_PATH.concat("/notification/read-all-notification"));
    }
    getPendingChangeRequestList = (cinNumber: string) => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-detail-service/get-pending-change-request-list/").concat(ParamEncrypt.encryptData(cinNumber)));
    }
    fetchTotalWealth = (cinNumber: string) => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-detail-service/get-total-wealth-and-current-yield/").concat(ParamEncrypt.encryptData(cinNumber)));
    }

    changeUserPassword = (userMstDto: UserMstDto) => {
        return HttpService.post(CONTEXT_PATH.concat("/customer-detail-service/change-password"), ParamEncrypt.encryptObject(userMstDto));
    }

    validateCurrentPassword = (userMstDto: UserMstDto) => {
        return HttpService.post(CONTEXT_PATH.concat("/customer-detail-service/validate-current-password"), ParamEncrypt.encryptObject(userMstDto));
    }

    customerOriginallySeen = (rmCode: string, customerId: string) => {
        return HttpService.post(CONTEXT_PATH.concat("/customer-detail-service/customer-originally-seen/").concat(true + "/").concat(ParamEncrypt.encryptData(rmCode)).concat("/").concat(ParamEncrypt.encryptData(customerId)),null);
    }

    fetchCustomerWisePortfolios = (customerId: number) => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-detail-service/get-all-customer-portfolio-list/").concat(ParamEncrypt.encryptData(String(customerId))));
    }

    getAccountSummaryForDashboard = (portfolioId: number) => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-detail-service/get-account-summary-for-dashboard/").concat(ParamEncrypt.encryptData(String(portfolioId))));
    }

    getCombineAccountSummaryForDashboard = (cinNumber: string) => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-detail-service/get-customer-account-summary-for-dashboard/").concat(ParamEncrypt.encryptData(cinNumber)));
    }

    fetchAccountCardDetail = (customerId: number, portfolioId: number) => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-detail-service/get-account-card-detail/").concat(ParamEncrypt.encryptData(String(portfolioId))).concat("/").concat(ParamEncrypt.encryptData(String(customerId))));
    }
    fetchCombineAccountCardDetail = (customerId: number) => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-detail-service/get-combine-view-card-detail/").concat(ParamEncrypt.encryptData(String(customerId))));
    }

    saveSelectedPortfolioInDashboard = (customerId: number, portfolioId: number) => {
        return HttpService.get(CONTEXT_PATH.concat("/customer-detail-service/save-selected-portfolio/").concat(ParamEncrypt.encryptData(String(customerId))).concat("/").concat(ParamEncrypt.encryptData(String(portfolioId))));
    }
}

const customerService = new CustomerService();
export default customerService;